<script lang="ts">
	import { ParameterCard, ParameterCardGroup } from '@Shelly/shelly-design-system/index';
	import { capFirstChar } from 'src/helpers/utilities';
	import { format } from 'svelte-i18n';

	export let pillMode, mainLabel, statuses;

	const getTempHumidityCard = () => {
		return (
			statuses.reduce((acc, i) => {
				if (i.peripheralType === 'temperature' || i.peripheralType === 'humidity') {
					acc.push({
						icon: i.icon,
						iconColor: i?.iconColor,
						title: i?.value,
						description: capFirstChar(
							$format(`title_chart_${i.peripheralType}`, {
								default: i.peripheralType,
							}) || '',
						),
					});
				}
				return acc;
			}, []) || []
		);
	};
</script>

{#if pillMode === 'dht22'}
	<ParameterCardGroup sectionParameters={getTempHumidityCard()} />
{:else}
	<ParameterCard
		icon={mainLabel.icon}
		iconColor={mainLabel?.iconColor || ''}
		title={capFirstChar(mainLabel?.value)}
		description={mainLabel?.sensor?.name || ''}
	/>
{/if}
